// import lib
import isEmpty, { isFileEmpty } from "./isEmpty"

// regexes
// const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\W).{6,18}(?!\S)$/;

const camelCaseToString = (str) => str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());

const min = (length, valueLen) => {
    if (length > valueLen) {
        return {
            status: false,
            message: `Minimum length is ${length} letters.`
        }
    }

    return {
        status: true
    }
}

const max = (length, valueLen) => {
    if (length < valueLen) {
        return {
            status: false,
            message: `Maximum length is ${length} letters.`
        }
    }

    return {
        status: true
    }
}

const isValidDate = (dateString) => {
    try {
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date);
    } catch (err) {
        return false
    }
}

const isValidUrl = (url) => {
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
}

const isStringifiedObject = (value) => {
    if (typeof value !== "string") return false;
    try {
        const parsed = JSON.parse(value);
        return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed);
    } catch (e) {
        return false;
    }
}

const stringValid = (errors, bodyValue, key, value) => {
    let checkVal = isEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (value?.regex === 'email') {
        if (!emailRegex.test(bodyValue)) {
            errors[key] = `${camelCaseToString(key)} is invalid`;
        }
    } else if (value?.regex === 'password') {
        if (!passwordRegex.test(bodyValue)) {
            errors[key] = `${camelCaseToString(key)} should contain atleast one uppercase, atleast one lowercase, atleast one number, atleast one special character and minimum 6 and maximum 18`;
        }
    } else if (value?.min) {
        let { status, message } = min(value?.min, bodyValue.length)
        if (!status) errors[key] = message
        else if (value?.max) {
            let { status, message } = max(value?.max, bodyValue.length)
            if (!status) errors[key] = message
        }
    } else if (!isEmpty(value?.enum) && !value?.enum?.includes(bodyValue)) {
        errors[key] = `Invalid ${camelCaseToString(key)}`
    } else if (!isEmpty(value?.isEqual) && bodyValue != value?.isEqual) {
        errors[key] = `${camelCaseToString(key)} must same`
    }
}

const numberValid = (errors, bodyValue, key, value) => {
    let checkVal = isEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (isNaN(bodyValue)) errors[key] = `${camelCaseToString(key)} field is only allowed for numbers`;
    else if (value?.length && bodyValue?.toString()?.length !== value?.length) errors[key] = `${camelCaseToString(key)} field allwoed for ${value?.length} lengths`;
    else if (value?.min) {
        let { status, message } = min(value?.min, bodyValue)
        if (!status) errors[key] = message
        else if (value?.max) {
            let { status, message } = max(value?.max, bodyValue)
            if (!status) errors[key] = message
        }
    }
}

const objectValid = (errors, bodyValue, key, value) => {
    if (!isEmpty(value?.validation)) {
        let validDoc = value?.validation;
        let reqBody = bodyValue;
        const valHelper = validHelper(validDoc, reqBody);
        if (!valHelper.status) return errors[key] = valHelper.errors;
    } else {
        let checkVal = isEmpty(bodyValue);
        if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    }
}

const arrayValid = (errors, bodyValue, key, value) => {
    if (!Array.isArray(bodyValue)) {
        errors[key] = `${camelCaseToString(key)} should be array format`;
    } else if (!isEmpty(value?.minLength) && bodyValue.length < value?.minLength) {
        errors[key] = `${camelCaseToString(key)} array lengths should be minimum ${value?.minLength} elements`
    } else if (!isEmpty(value?.maxLength) && bodyValue.length > value?.maxLength) {
        errors[key] = `${camelCaseToString(key)} array lengths should be maximum ${value?.maxLength} elements`
    } else if (!isEmpty(value?.length) && bodyValue.length != value?.length) {
        errors[key] = `${camelCaseToString(key)} array lengths should be ${value?.length} elements`
    } else if (!isEmpty(value?.enumRequired) && value?.elementType === 'string') {
        let validKeys = value?.enumRequired;
        let reqKeys = bodyValue;
        let extraKeys = [];
        for (let key of reqKeys) {
            if (validKeys.includes(key)) continue;
            extraKeys.push(key)
        }

        if (!isEmpty(extraKeys)) {
            errors[key] = `${validKeys.join(',')} these fileds are only alloweds`
        }
    } else if (value?.elementType == 'object' && Array.isArray(bodyValue)) {
        let i = 0;
        for (let item of bodyValue) {
            i = i + 1;
            if (typeof item != value?.elementType) {
                errors[key] = `${camelCaseToString(key)} in every elemets should be type of ${value?.elementType}`
            } else if (!isEmpty(value.validation)) {
                let validErr = {};
                objectValid(validErr, item, (key + i), value)
                if (!isEmpty(validErr)) {
                    errors[key] = { ...errors[key] ? errors[key] : {}, ...validErr }
                }
            }
        }
    } else if (!isEmpty(value?.elementType)) {
        let i = 0;
        for (let item of bodyValue) {
            if (value?.elementType == 'number') {
                if (isNaN(item)) {
                    errors[key] = `${camelCaseToString(key)} in every elemets should be type of ${value?.elementType}`
                }
            } else if (value?.elementType == 'string') {
                i = i + 1;
                if (typeof item != value?.elementType) {
                    errors[key] = `${camelCaseToString(key)} in every elemets should be type of ${value?.elementType}`
                } else if (isEmpty(item)) {
                    let validErr = {};
                    stringValid(validErr, item, (key + i), value)
                    if (!isEmpty(validErr)) {
                        errors[key] = { ...errors[key] ? errors[key] : {}, ...validErr }
                    }
                }
            }
        }
    }
}

const booleanValid = (errors, bodyValue, key) => {
    let checkVal = isEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (!(typeof bodyValue === 'boolean')) errors[key] = `${camelCaseToString(key)} field is not boolean`;
}

const fileValid = (errors, bodyValue, key, value) => {
    let checkVal = isFileEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (!isEmpty(value?.acceptExt) && !value?.acceptExt.includes(bodyValue?.name?.split('.').pop())) {
        errors[key] = `${camelCaseToString(key)} allowed for ${value?.acceptExt.join(',')} formats only`;
    }
}

const urlValid = (errors, bodyValue, key) => {
    let checkVal = isEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (!isValidUrl(bodyValue)) {
        errors[key] = `${camelCaseToString(key)} is invalid`
    }
}

const dateValid = (errors, bodyValue, key, value) => {
    let checkVal = isEmpty(bodyValue.toString());
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (!isValidDate(bodyValue)) {
        errors[key] = `${camelCaseToString(key)} is invalid`
    } else if (!isEmpty(value.lesserThan)) {
        if (new Date(bodyValue) > new Date(value.lesserThan)) {
            errors[key] = `${camelCaseToString(key)} date is should be lesser than ${new Date(value.less)} date`
        }
    } else if (!isEmpty(value.greaterThan)) {
        if (new Date(bodyValue) < new Date(value.greaterThan)) {
            errors[key] = `${camelCaseToString(key)} date is should be greater than ${new Date(value.less)} date`
        }
    }
}

const stringifyValid = (errors, bodyValue, key, value) => {
    let checkVal = isEmpty(bodyValue);
    if (checkVal) errors[key] = `${camelCaseToString(key)} field is required`;
    else if (!isStringifiedObject(bodyValue) && value.elementType == 'object') {
        errors[key] = `${camelCaseToString(key)} is invalid object`
    } else if (isStringifiedObject(bodyValue) && value.elementType == 'object') {
        let json = JSON.parse(bodyValue);
        if (isEmpty(json)) {
            errors[key] = `${camelCaseToString(key)} is empty object`
        }
    }
}

const validHelper = (valid, reqBody) => {
    let errors = {};
    for (let [key, value] of Object.entries(valid)) {
        let bodyValue = reqBody[key];

        if (value?.type === 'string' && value?.required) {
            stringValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'number' && value?.required) {
            numberValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'boolean' && value?.required) {
            booleanValid(errors, bodyValue, key)
        }

        if (value?.type === 'object' && value?.required) {
            objectValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'array' && value?.required) {
            arrayValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'file' && value?.required) {
            fileValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'url' && value?.required) {
            urlValid(errors, bodyValue, key)
        }

        if (value?.type === 'date' && value?.required) {
            dateValid(errors, bodyValue, key, value)
        }

        if (value?.type === 'stringify' && value?.required) {
            stringifyValid(errors, bodyValue, key, value)
        }
    }

    if (!isEmpty(errors)) {
        return { 'status': false, errors }
    }

    return {
        'status': true
    }

}

export default validHelper;